import json from './sprite.js';

export default {
    handle: 'ENG_SPS2-FavoriteToy',
    label: 'en_SPS2-FavoriteToy_225002224',
    json,
};
